(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colostrum-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.cg:not([data-guide-ready])').forEach((guide) => {
      guide.dataset.guideReady = 'true';
      let fitVisible = false;
      let refreshSticky = () => {};
      const published = new Set();
      const publish = (name) => {
        const shopify = window.Shopify;
        if (published.has(name) || shopify?.designMode) return;
        if (typeof shopify?.analytics?.publish !== 'function' || typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
        if (!shopify.customerPrivacy.analyticsProcessingAllowed()) return;
        try {
          const result = shopify.analytics.publish(`olnian:${name}`, { guide: 'colostrum' });
          if (result && typeof result.catch === 'function') result.catch(() => {});
          published.add(name);
        } catch {}
      };
      guide.querySelector('.cg-actions .cg-button')?.addEventListener('click', () => publish('colostrum_guide_explored'));
      guide.querySelector('.cg-product-form')?.addEventListener('submit', () => publish('colostrum_purchase_clicked'));
      const fit = guide.querySelector('[data-tree]');
      const result = guide.querySelector('[data-tree-result]');
      if (fit && result) {
        fit.hidden = false;
        guide.querySelectorAll('[data-tree-choice]').forEach((button) => {
          button.addEventListener('click', () => {
            const choice = button.dataset.treeChoice;
            const path = choice === 'digestion' ? 'gut' : choice;
            const template = guide.querySelector(`[data-tree-template="${path}"]`);
            if (!template) return;
            guide.querySelectorAll('[data-tree-choice]').forEach((item) => {
              item.setAttribute('aria-pressed', String(item.dataset.treeChoice === choice));
            });
            result.replaceChildren(template.content.cloneNode(true));
            publish('colostrum_guide_explored');
            guide.querySelector('[data-tree-more]').hidden = false;
            result.querySelector('h3').focus({ preventScroll: true });
            result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
          });
        });
      }
      const sticky = guide.querySelector('.cg-sticky');
      const hero = guide.querySelector('.cg-hero');
      const offer = guide.querySelector('.cg-offer');
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile && sticky) {
        window.setTimeout(() => { sticky.hidden = false; }, 2000);
      } else if ('IntersectionObserver' in window && sticky && hero && offer) {
        let pastHero = false;
        let reachedOffer = false;
        refreshSticky = () => { sticky.hidden = !pastHero || reachedOffer || fitVisible; };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === fit) fitVisible = entry.isIntersecting;
            if (entry.target === hero) pastHero = entry.boundingClientRect.bottom < 0;
            if (entry.target === offer) {
              reachedOffer = entry.isIntersecting || entry.boundingClientRect.top < 0;
              if (entry.isIntersecting) publish('colostrum_offer_viewed');
            }
          });
          refreshSticky();
        });
        observer.observe(hero);
        observer.observe(offer);
        if (fit) observer.observe(fit);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(guide)) observer.disconnect();
        }, { once: true });
      }
      const emailDialog = guide.querySelector('.cg-email-dialog');
      if (emailDialog) {
        let emailOpener;
        const openEmail = () => {
          emailOpener = document.activeElement;
          if (!emailDialog.open) emailDialog.showModal();
          (emailDialog.querySelector('[data-email-status]') || emailDialog.querySelector('input[type="email"]'))?.focus();
        };
        guide.querySelectorAll('[data-email-open]').forEach(button => button.addEventListener('click', openEmail));
        emailDialog.querySelector('[data-email-close]').addEventListener('click', () => emailDialog.close());
        emailDialog.addEventListener('click', event => {
          if (event.target !== emailDialog) return;
          const box = emailDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) emailDialog.close();
        });
        emailDialog.addEventListener('close', () => emailOpener?.focus());
        if (emailDialog.querySelector('[data-email-status]')) openEmail();
      }
      const variants = guide.querySelector('[data-guide-variant]');
      if (variants) variants.addEventListener('change', () => {
        const option = variants.selectedOptions[0];
        const price = guide.querySelector('[data-guide-price]');
        const original = guide.querySelector('[data-guide-original]');
        const serving = guide.querySelector('[data-guide-serving]');
        if (price) price.textContent = option.dataset.price;
        if (original) original.textContent = option.dataset.original;
        if (serving) serving.textContent = option.dataset.serving;
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colostrum-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.clp:not([data-clp-ready])').forEach((lp) => {
      lp.dataset.clpReady = 'true';
      const offerCode = lp.dataset.offerCode || '';

      /* Consent-gated custom events; standard add-to-cart tracking comes from
         Shopify's own pixel instrumentation of the Cart API call. */
      const published = new Set();
      const publish = (name) => {
        const shopify = window.Shopify;
        if (published.has(name) || shopify?.designMode) return;
        if (typeof shopify?.analytics?.publish !== 'function' || typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
        if (!shopify.customerPrivacy.analyticsProcessingAllowed()) return;
        try {
          const result = shopify.analytics.publish(`olnian:${name}`, { guide: 'colostrum' });
          if (result && typeof result.catch === 'function') result.catch(() => {});
          published.add(name);
        } catch {}
      };

      /* One handler for every buy form on the page (hero + closing). */
      lp.querySelectorAll('.clp-form').forEach((form) => {
        const qty = form.querySelector('[name="quantity"]');
        const submitBtn = form.querySelector('.clp-submit');
        const status = form.querySelector('[data-clp-status]');

        form.querySelectorAll('[data-clp-step]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (!qty) return;
            const min = Number(qty.min || 1);
            const max = Number(qty.max || 10);
            const next = (parseInt(qty.value, 10) || min) + Number(btn.dataset.clpStep);
            qty.value = Math.min(max, Math.max(min, next));
          });
        });

        const variantSelect = form.querySelector('[data-clp-variant]');
        if (variantSelect) {
          variantSelect.addEventListener('change', () => {
            const option = variantSelect.selectedOptions[0];
            if (!option) return;
            lp.querySelectorAll('[data-clp-price]').forEach((el) => { el.textContent = option.dataset.price; });
            lp.querySelectorAll('[data-clp-original]').forEach((el) => { el.textContent = option.dataset.original; });
            const stickyPrice = lp.querySelector('[data-clp-sticky-price]');
            if (stickyPrice) stickyPrice.textContent = option.dataset.price;
          });
        }

        form.addEventListener('submit', async (e) => {
          const api = window.OlnianCart;
          if (!api) return; // theme.js unavailable: let the native POST proceed
          e.preventDefault();
          if (!submitBtn || submitBtn.disabled) return;
          const idInput = form.querySelector('[name="id"]');
          const payload = {
            id: Number(idInput && idInput.value),
            quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1),
          };
          if (!payload.id) return;
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
          submitBtn.textContent = submitBtn.dataset.addingLabel || submitBtn.textContent;
          if (status) status.textContent = '';
          publish('colostrum_purchase_clicked');
          try {
            // One-time purchase by construction: the payload never carries a selling plan.
            await api.add([payload]);
            if (offerCode) {
              // Attach the welcome code to the cart so it survives to checkout, where
              // first-order eligibility is decided. Failure here must not undo the add.
              try { await api.applyDiscount(offerCode); } catch (_) {}
            }
            if (status) status.textContent = status.dataset.added || '';
            api.openDrawer();
          } catch (err) {
            if (status) status.textContent = (err && err.message) || (status && status.dataset.error) || '';
          } finally {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
            submitBtn.textContent = submitBtn.dataset.label || submitBtn.textContent;
          }
        });
      });

      /* Mobile sticky bar: appears once the hero buy box scrolls out of view, hides
         near the closing purchase section and footer so it never covers them. */
      const sticky = lp.querySelector('[data-clp-sticky]');
      const heroBuy = lp.querySelector('.clp-hero .clp-buy');
      const closing = lp.querySelector('.clp-closing');
      const footer = lp.querySelector('.clp-footer');
      if ('IntersectionObserver' in window && sticky && heroBuy) {
        let pastHero = false;
        let closingVis = false;
        let footerVis = false;
        const refresh = () => { sticky.hidden = !pastHero || closingVis || footerVis; };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === heroBuy) {
              pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
              if (entry.isIntersecting) publish('colostrum_offer_viewed');
            }
            if (entry.target === closing) {
              closingVis = entry.isIntersecting;
              if (entry.isIntersecting) publish('colostrum_offer_viewed');
            }
            if (entry.target === footer) footerVis = entry.isIntersecting;
          });
          refresh();
        });
        observer.observe(heroBuy);
        if (closing) observer.observe(closing);
        if (footer) observer.observe(footer);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(lp)) observer.disconnect();
        }, { once: true });
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creatine-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.crg:not([data-guide-ready])').forEach((guide) => {
      guide.dataset.guideReady = 'true';
      let fitVisible = false;
      let refreshSticky = () => {};
      const published = new Set();
      const publish = (name) => {
        const shopify = window.Shopify;
        if (published.has(name) || shopify?.designMode) return;
        if (typeof shopify?.analytics?.publish !== 'function' || typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function') return;
        if (!shopify.customerPrivacy.analyticsProcessingAllowed()) return;
        try {
          const result = shopify.analytics.publish(`olnian:${name}`, { guide: 'creatine' });
          if (result && typeof result.catch === 'function') result.catch(() => {});
          published.add(name);
        } catch {}
      };
      guide.querySelector('.crg-actions .crg-button')?.addEventListener('click', () => publish('creatine_guide_explored'));
      guide.querySelector('.crg-product-form')?.addEventListener('submit', () => publish('creatine_purchase_clicked'));
      const fit = guide.querySelector('[data-tree]');
      const result = guide.querySelector('[data-tree-result]');
      if (fit && result) {
        fit.hidden = false;
        guide.querySelectorAll('[data-tree-choice]').forEach((button) => {
          button.addEventListener('click', () => {
            const choice = button.dataset.treeChoice;
            const path = choice;
            const template = guide.querySelector(`[data-tree-template="${path}"]`);
            if (!template) return;
            guide.querySelectorAll('[data-tree-choice]').forEach((item) => {
              item.setAttribute('aria-pressed', String(item.dataset.treeChoice === choice));
            });
            result.replaceChildren(template.content.cloneNode(true));
            publish('creatine_guide_explored');
            guide.querySelector('[data-tree-more]').hidden = false;
            result.querySelector('h3').focus({ preventScroll: true });
            result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
          });
        });
      }
      const sticky = guide.querySelector('.crg-sticky');
      const hero = guide.querySelector('.crg-hero');
      const offer = guide.querySelector('.crg-offer');
      if ('IntersectionObserver' in window && sticky && hero && offer) {
        let pastHero = false;
        let reachedOffer = false;
        refreshSticky = () => { sticky.hidden = !pastHero || reachedOffer || fitVisible; };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === fit) fitVisible = entry.isIntersecting;
            if (entry.target === hero) pastHero = entry.boundingClientRect.bottom < 0;
            if (entry.target === offer) {
              reachedOffer = entry.isIntersecting || entry.boundingClientRect.top < 0;
              if (entry.isIntersecting) publish('creatine_offer_viewed');
            }
          });
          refreshSticky();
        });
        observer.observe(hero);
        observer.observe(offer);
        if (fit) observer.observe(fit);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(guide)) observer.disconnect();
        }, { once: true });
      }
      const emailDialog = guide.querySelector('.crg-email-dialog');
      if (emailDialog) {
        let emailOpener;
        const openEmail = () => {
          emailOpener = document.activeElement;
          if (!emailDialog.open) emailDialog.showModal();
          (emailDialog.querySelector('[data-email-status]') || emailDialog.querySelector('input[type="email"]'))?.focus();
        };
        guide.querySelectorAll('[data-email-open]').forEach(button => button.addEventListener('click', openEmail));
        emailDialog.querySelector('[data-email-close]').addEventListener('click', () => emailDialog.close());
        emailDialog.addEventListener('click', event => {
          if (event.target !== emailDialog) return;
          const box = emailDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) emailDialog.close();
        });
        emailDialog.addEventListener('close', () => emailOpener?.focus());
        if (emailDialog.querySelector('[data-email-status]')) openEmail();
      }
      const variants = guide.querySelector('[data-guide-variant]');
      if (variants) variants.addEventListener('change', () => {
        const option = variants.selectedOptions[0];
        const price = guide.querySelector('[data-guide-price]');
        const original = guide.querySelector('[data-guide-original]');
        const serving = guide.querySelector('[data-guide-serving]');
        if (price) price.textContent = option.dataset.price;
        if (original) original.textContent = option.dataset.original;
        if (serving) serving.textContent = option.dataset.serving;
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp1-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.glg:not([data-guide-ready])').forEach((guide) => {
      guide.dataset.guideReady = 'true';
      const explorer = guide.querySelector('[data-ingredient-explorer]');
      if (explorer) {
        const groups = [...explorer.querySelectorAll('[data-ingredient-group]')];
        const picks = [...explorer.querySelectorAll('[data-ingredient-pick]')];
        const panels = [...explorer.querySelectorAll('[data-ingredient-panel]')];
        const contexts = [...explorer.querySelectorAll('[data-ingredient-context]')];
        const status = explorer.querySelector('[data-ingredient-status]');
        let category = 'nutrition';
        let selected = 'b12';
        const memories = {};
        const selectIngredient = (key, announce = true) => {
          const pick = picks.find((item) => item.dataset.ingredientPick === key);
          if (!pick) return;
          selected = key;
          category = pick.dataset.ingredientCategory;
          memories[category] = key;
          groups.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.ingredientGroup === category)));
          contexts.forEach((item) => { item.hidden = item.dataset.ingredientContext !== category; });
          picks.forEach((item) => {
            item.hidden = item.dataset.ingredientCategory !== category;
            item.setAttribute('aria-pressed', String(item === pick));
          });
          panels.forEach((item) => { item.hidden = item.dataset.ingredientPanel !== key; });
          const active = picks.filter((item) => item.dataset.ingredientCategory === category);
          explorer.querySelector('[data-ingredient-position]').textContent = `${active.indexOf(pick) + 1} / ${active.length}`;
          if (announce) status.textContent = `${status.dataset.prefix} ${pick.textContent.trim()}`;
        };
        groups.forEach((button) => button.addEventListener('click', () => {
          const group = button.dataset.ingredientGroup;
          selectIngredient(memories[group] || picks.find((item) => item.dataset.ingredientCategory === group).dataset.ingredientPick);
        }));
        picks.forEach((button) => button.addEventListener('click', () => selectIngredient(button.dataset.ingredientPick)));
        explorer.querySelectorAll('[data-ingredient-step]').forEach((button) => button.addEventListener('click', () => {
          const active = picks.filter((item) => item.dataset.ingredientCategory === category);
          const index = active.findIndex((item) => item.dataset.ingredientPick === selected);
          selectIngredient(active[(index + Number(button.dataset.ingredientStep) + active.length) % active.length].dataset.ingredientPick);
        }));
        explorer.dataset.enhanced = 'true';
        explorer.querySelectorAll('[data-ingredient-controls]').forEach((item) => { item.hidden = false; });
        selectIngredient(selected, false);
      }
      let fitVisible = false;
      let refreshSticky = () => {};
      const fit = guide.querySelector('[data-tree]');
      const result = guide.querySelector('[data-tree-result]');
      if (fit && result) {
        fit.hidden = false;
        guide.querySelectorAll('[data-tree-choice]').forEach((button) => {
          button.addEventListener('click', () => {
            const choice = button.dataset.treeChoice;
            const path = choice;
            const template = guide.querySelector(`[data-tree-template="${path}"]`);
            if (!template) return;
            guide.querySelectorAll('[data-tree-choice]').forEach((item) => {
              item.setAttribute('aria-pressed', String(item.dataset.treeChoice === choice));
            });
            result.replaceChildren(template.content.cloneNode(true));
            guide.querySelector('[data-tree-more]').hidden = false;
            result.querySelector('h3').focus({ preventScroll: true });
            result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
          });
        });
      }
      const sticky = guide.querySelector('.glg-sticky');
      const hero = guide.querySelector('.glg-hero');
      const offer = guide.querySelector('.glg-offer');
      if ('IntersectionObserver' in window && sticky && hero && offer) {
        let pastHero = false;
        let reachedOffer = false;
        refreshSticky = () => { sticky.hidden = !pastHero || reachedOffer || fitVisible; };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === fit) fitVisible = entry.isIntersecting;
            if (entry.target === hero) pastHero = entry.boundingClientRect.bottom < 0;
            if (entry.target === offer) {
              reachedOffer = entry.isIntersecting || entry.boundingClientRect.top < 0;
            }
          });
          refreshSticky();
        });
        observer.observe(hero);
        observer.observe(offer);
        if (fit) observer.observe(fit);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(guide)) observer.disconnect();
        }, { once: true });
      }
      const emailDialog = guide.querySelector('.glg-email-dialog');
      if (emailDialog) {
        let emailOpener;
        const openEmail = () => {
          emailOpener = document.activeElement;
          if (!emailDialog.open) emailDialog.showModal();
          (emailDialog.querySelector('[data-email-status]') || emailDialog.querySelector('input[type="email"]'))?.focus();
        };
        guide.querySelectorAll('[data-email-open]').forEach(button => button.addEventListener('click', openEmail));
        emailDialog.querySelector('[data-email-close]').addEventListener('click', () => emailDialog.close());
        emailDialog.addEventListener('click', event => {
          if (event.target !== emailDialog) return;
          const box = emailDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) emailDialog.close();
        });
        emailDialog.addEventListener('close', () => emailOpener?.focus());
        if (emailDialog.querySelector('[data-email-status]')) openEmail();
      }
      const liveOffer = guide.querySelector('[data-live-offer]');
      if (liveOffer) {
        fetch(liveOffer.dataset.productUrl + '.js', { credentials: 'same-origin' })
          .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
          .then(product => {
            const variant = product.variants.find(item => String(item.id) === '44512991608898');
            if (!variant || variant.requires_selling_plan) return;
            const percent = Number(liveOffer.dataset.percent) || 0;
            const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:liveOffer.dataset.currency || 'USD'});
            liveOffer.querySelector('[data-guide-price]').textContent = money.format(Math.round(variant.price * (100-percent) / 100) / 100);
            const original = liveOffer.querySelector('[data-guide-original]');
            if (original) original.textContent = money.format(variant.price / 100);
            const button = liveOffer.querySelector('.glg-buy');
            button.disabled = !variant.available;
            button.textContent = !variant.available ? liveOffer.dataset.soldLabel : percent > 0 ? liveOffer.dataset.buyLabel : liveOffer.dataset.standardLabel;
            liveOffer.hidden = false;
          }).catch(() => {});
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
